export const toTime = (seconds: number) => {
  // Calculate hours, minutes, and seconds directly from total seconds
  // to handle durations larger than 24 hours correctly
  const totalSeconds = Math.floor(seconds)
  const hh = Math.floor(totalSeconds / 3600)
  const mm = Math.floor((totalSeconds % 3600) / 60)
  const ss = totalSeconds % 60

  if (hh) {
    return `${hh}:${mm.toString().padStart(2, '0')}:${ss
      .toString()
      .padStart(2, '0')}`
  }

  return `${mm}:${ss.toString().padStart(2, '0')}`
}
